<template>
  <div>
    <a-form v-if="hasCustomerProperty" layout="vertical">
      <a-row :gutter="16">
        <a-col :span="12">

          <a-form-item>
            <label>
              Registratiedatum
              <a-popover placement="top">
                <template slot="content">
                  <span>Dit gaat om de registratiedatum van het bovenstaande adres</span>
                  <br>
                  <span>Vul in door door de juiste datum aan te klikken of handmatig met het formaat 'DD/MM/YYYY'</span>
                </template>
                <information-outline-icon/>
              </a-popover>
            </label>
            <date-picker-component v-model="customerPropertyObject.registration_date"
                                   :block="true"
                                   :disabled="disabled"
                                   v-on:change="onChange"
            />
          </a-form-item>

        </a-col>
        <a-col :span="12">
          <a-form-item>
            <label>Gemeentelijke registratiedatum
              <a-popover placement="top">
                <template slot="content">
                  <span>Dit veld wordt automatisch gevuld bij een brondata sessie</span>
                </template>
                <information-outline-icon/>
              </a-popover>
            </label>
            <date-picker-component v-model="customerPropertyObject.municipality_registration_date"
                                   :block="true"
                                   :disabled="true"
                                   v-on:change="onChange"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <template v-if="detailed">
        <a-row v-if="currentTogglable" :gutter="16">
          <!--        <a-col :span="12">-->
          <!--          <a-form-item label="Transactiedatum">-->
          <!--            <date-picker-component v-model="customerPropertyObject.transaction_date"-->
          <!--                                   :block="true"-->
          <!--                                   :disabled="disabled"-->
          <!--                                   v-on:change="onChange"-->
          <!--            />-->
          <!--          </a-form-item>-->
          <!--        </a-col>-->
          <a-col :span="12">
            <a-form-item label="Is huidig adres">
              <a-radio-group
                  :disabled="disabled"
                  :value="customerPropertyObject.is_current"
                  button-style="solid"
                  v-on:change="handleUpdateIsCurrent">
                <a-radio-button :value="true">
                  Ja
                </a-radio-button>
                <a-popconfirm
                    cancel-text="Annuleren"
                    ok-text="Ja"
                    placement="topRight"
                    title="Weet je zeker dat je dit pand wilt ontkoppelen als huidig adres?"
                    @confirm="handleUpdateIsCurrent"
                >
                  <a-radio-button :value="false">
                    Nee
                  </a-radio-button>
                </a-popconfirm>
              </a-radio-group>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-item label="Woont samen">
              <a-radio-group v-model="customerPropertyObject.living_together"
                             :disabled="disabled"
                             button-style="solid"
                             v-on:change="handleLivingTogetherChange">
                <a-radio-button :value="true">
                  Ja
                </a-radio-button>
                <a-radio-button :value="false">
                  Nee
                </a-radio-button>
              </a-radio-group>
            </a-form-item>
          </a-col>
          <a-col v-if="showRentalFields" :span="12">
            <a-form-item label="Huurcontract staat op naam van">
              <a-radio-group v-if="isMainCustomer"
                             v-model="customerPropertyObject.contract_owner"
                             :disabled="disabled"
                             button-style="solid" v-on:change="handleContractOwnerChanged">
                <a-radio-button value="main_customer">
                  {{ customerName }}
                </a-radio-button>
                <a-radio-button v-if="hasPartner" value="partner">
                  {{ partnerName }}
                </a-radio-button>
                <a-radio-button v-if="hasPartner" value="both">
                  Beide
                </a-radio-button>
                <a-radio-button value="other">
                  Anders
                </a-radio-button>
              </a-radio-group>
              <a-radio-group v-else
                             v-model="customerPropertyObject.contract_owner"
                             :disabled="disabled"
                             button-style="solid" v-on:change="handleContractOwnerChanged">
                <a-radio-button value="main_customer">
                  {{ partnerName }}
                </a-radio-button>
                <a-radio-button v-if="hasPartner" value="partner">
                  {{ customerName }}
                </a-radio-button>
                <a-radio-button v-if="hasPartner" value="both">
                  Beide
                </a-radio-button>
                <a-radio-button value="other">
                  Anders
                </a-radio-button>
              </a-radio-group>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col v-if="withAddressType" :span="12">
            <a-form-item label="Adres type">
              <a-select v-model="customerPropertyObject.address_type"
                        :disabled="disabled"
                        placeholder="Selecteer een adres type"
                        v-on:change="onChange"
              >
                <a-select-option v-for="(addressTypeName, addressType) in this.address_type"
                                 :key="addressType" :value="addressType">
                  {{ addressTypeName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="Doel van de woning">
              <a-select v-model="customerPropertyObject.property_purpose"
                        :disabled="disabled"
                        placeholder="Doel van de woning"
                        v-on:change="onChange"
              >
                <a-select-option v-for="(purposeName, purpose) in this.propertyPurposes"
                                 :key="purpose" :value="purpose">
                  {{ purposeName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-item label="Eigenaar adres">
              <a-radio-group v-model="customerPropertyObject.owns_property"
                             :disabled="disabled"
                             button-style="solid"
                             v-on:change="onChangeIsOwner">
                <a-radio-button :value="true">
                  Ja
                </a-radio-button>
                <a-radio-button :value="false">
                  Nee
                </a-radio-button>
              </a-radio-group>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row v-if="customerPropertyObject.owns_property" :gutter="16">
          <a-col :span="12">
            <a-form-item :label="'Deel ' + customerName">
              <a-input
                  v-model="customerPropertyObject.percentage_owner"
                  :disabled="disabled"
                  addon-after="%"
                  type="number"
                  @change="handlePercentageOwnerChanged"
              />
            </a-form-item>
          </a-col>
          <a-col v-if="hasPartner" :span="12">
            <a-form-item :label="'Deel ' + partnerName">
              <a-input
                  v-model="partnerOwnerPercentageObject"
                  :disabled="!manualInput"
                  addon-after="%"
                  type="number"
                  @change="handlePartnerOwnerPercentageManualInput"
              />
              <a-checkbox @change="handleManualInput">Handmatig invoeren</a-checkbox>
            </a-form-item>
          </a-col>
        </a-row>
      </template>
      <!--      <a-row-->
      <!--          v-if="restPercentage > 0 && customerPropertyObject.owns_property"-->
      <!--          :gutter="16">-->
      <!--        <a-col :span="12">-->
      <!--          <a-form-item :label="'Deel derden'">-->
      <!--            <a-input-->
      <!--                v-model="restPercentage"-->
      <!--                :disabled="!manualInputRest"-->
      <!--                addon-after="%"-->
      <!--                type="number"-->
      <!--            />-->
      <!--            &lt;!&ndash;            <a-checkbox @change="handleManualInputRest">Handmatig invoeren</a-checkbox>&ndash;&gt;-->
      <!--          </a-form-item>-->
      <!--        </a-col>-->
      <!--      </a-row>-->
      <a-alert v-if="percentageOver100"
               message="Het totale eigendomspercentage is groter dan 100% controleer de gegevens"
               show-icon
               type="warning"
      />
    </a-form>

  </div>
</template>

<script>
import customerPropertyApi from "~/api/customer_property";
import customerApi from "~/api/customer"
import {OccupancyTypeEnum} from "../../../enums";

export default {
  name: "CustomerPropertyEditComponent",
  props: {
    customerProperty: {
      type: Object,
      required: true
    },
    currentLivingCondition: {
      type: Object,
      required: false
    },
    autoSave: {
      type: Boolean,
      required: false,
      default: false
    },
    autoUpdate: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    withAddressType: {
      type: Boolean,
      required: false,
      default: true
    },
    property: {
      type: Object,
      required: false,
      default: null
    },
    partnerOwnerPercentage: {
      type: [Number, String],
      required: false,
      default: null
    },
    detailed: {
      type: Boolean,
      required: false,
      default: false
    },
    currentTogglable: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      address_type: {
        mail: 'Postadres',
        visit: 'Bezoekadres',
        establishment: 'Vestiging',
      },
      customerPropertyObject: this.customerProperty,
      partnerData: null,
      customer: null,
      partnerOwnerPercentageObject: this.partnerOwnerPercentage,
      manualInput: false,
      manualInputRest: false,
      persistTimeout: 0,
      propertyPurposes: {
        "keep_living": "Blijven wonen",
        "sell": "Verkopen",
        "sold": "Verkocht",
      }
    };
  },
  computed: {
    hasCustomerProperty() {
      return this.customerPropertyObject !== null && typeof this.customerPropertyObject !== 'undefined';
    },
    propertyOccupancyType() {
      if (typeof this.currentLivingCondition !== "undefined" && this.currentLivingCondition !== null) {
        return this.currentLivingCondition.type
      }
      return null;
    },
    showRentalFields() {
      if (typeof this.currentLivingCondition !== "undefined" && this.currentLivingCondition !== null) {
        return this.currentLivingCondition.type === OccupancyTypeEnum.RENTAL;
      }
      return false;
    },
    hasPartner() {
      return this.partnerData !== null;
    },
    partnerName() {
      if (this.partnerData !== null && typeof this.partnerData !== 'undefined') {
        return this.partnerData.full_name ? this.partnerData.full_name : 'Partner';
      }
      return 'Partner'
    },
    customerName() {
      if (this.customer !== null && typeof this.customer !== 'undefined') {
        return this.customer.full_name ? this.customer.full_name : 'Klant';
      }
      return 'Klant'
    },
    totalPercentage() {
      if (this.customerPropertyObject !== null && typeof this.customerPropertyObject !== 'undefined') {
        let percentage = this.customerPropertyObject.percentage_owner
        if (this.partnerOwnerPercentageObject) {
          percentage += this.partnerOwnerPercentageObject
        }
        return percentage;
      }
    },
    percentageOver100() {
      return this.totalPercentage > 100
    },
    percentageUnder100() {
      return this.totalPercentage < 100
    },
    restPercentage() {
      return 100 - this.customerPropertyObject.percentage_owner - this.partnerOwnerPercentageObject;
    },
    isMainCustomer() {
      if (this.customer !== null && typeof this.customer !== 'undefined') {
        return this.customer.is_main_customer
      }
    }
  },
  mounted() {
    if (
        typeof this.customerPropertyObject !== 'undefined'
        && this.customerPropertyObject !== null
        && typeof this.customerPropertyObject.customer !== 'undefined'
        && this.customerPropertyObject.customer !== null
        && typeof this.customerPropertyObject.customer.data !== 'undefined'
        && this.customerPropertyObject.customer.data !== null
    ) {
      this.customer = this.customerPropertyObject.customer.data;
    } else if (
        typeof this.customerPropertyObject !== 'undefined'
        && this.customerPropertyObject !== null
    ) {
      this.initCustomer();
    }
    if (
        this.customerPropertyObject !== null
        && typeof this.customerPropertyObject !== 'undefined'
        && this.hasPartner
    ) {
      this.initPartner();
    }
    // if (
    //     this.customerPropertyObject !== null
    //     && typeof this.customerPropertyObject !== 'undefined'
    //     && this.prefillRegistrationDate
    // ) {
    //   // this.handlePrefillRegistrationDate();
    // }
  },
  methods: {
    onChange() {
      if (this.autoSave) {
        this.save();
      }
      if (this.autoUpdate) {
        this.update();
      }
    },
    onChangeIsOwner() {
      if (this.hasPartner) {

      }

      if (this.autoSave) {
        this.save();
      }
      if (this.autoUpdate) {
        this.update();
      }
    },
    setIsCurrent() {
      this.customerPropertyObject.is_current = true;
    },
    initCustomer() {
      customerApi.find(this.customerPropertyObject.customer_id).then(response => {
        this.customer = response.data
      }).catch();
    },
    initPartner() {
      customerApi.findPartnerByCustomerId(this.customerPropertyObject.customer_id, ['current_visit_customer_property']).then(response => {
        this.partnerData = response.data;
      }).catch();
    },
    handleUpdateIsCurrent() {
      this.customerPropertyObject.is_current = !this.customerPropertyObject.is_current;
      this.onChange();

    },
    handlePercentageOwnerChanged() {
      if (this.hasPartner) {
        this.partnerOwnerPercentageObject = 100 - this.customerPropertyObject.percentage_owner
        this.$emit('partner-owner-percentage-changed', this.partnerOwnerPercentageObject);

      }

      if (this.autoSave) {
        this.save();
      }
      if (this.autoUpdate) {
        this.update();
      }
    },
    handleLivingTogetherChange() {
      // if (this.customerPropertyObject.living_together) {
      //   this.initPartner();
      // } else {
      //   this.partnerData = null;
      // }

      if (this.autoSave) {
        this.save();
      }
      if (this.autoUpdate) {
        this.update();
      }
    },
    handleContractOwnerChanged() {
      if (this.autoSave) {
        this.save();
      }
      if (this.autoUpdate) {
        this.update();
      }
    },
    handleManualInput() {
      this.manualInput = !this.manualInput;
    },
    handleManualInputRest() {
      this.manualInputRest = !this.manualInputRest;
    },
    handlePartnerOwnerPercentageManualInput() {
      this.$emit('partner-owner-percentage-changed', this.partnerOwnerPercentageObject);
      if (this.autoSave) {
        this.save();
        // update partner
      }
      if (this.autoUpdate) {
        this.update();
      }
    },
    save() {
      clearTimeout(this.persistTimeout);

      this.persistTimeout = setTimeout(() => {
        customerPropertyApi.update(this.customerPropertyObject).then(() => {
          this.$emit('save', this.customerPropertyObject);
        }).then(response => {
          if (this.partnerData !== null) {
            this.partnerOwnerPercentageObject = this.partnerData.current_visit_customer_property.data.percentage_owner
          } else {
            this.partnerOwnerPercentageObject = this.restPercentage;
          }
        }).catch((error) => {
          this.$message.error('Er ging iets fout tijdens het opslaan');
          this.$emit('error', error);
        });
      }, 500);
    },
    update() {
      this.persistTimeout = setTimeout(() => {
        this.$emit('save', this.customerPropertyObject);
      }, 500);
    },
  }
}
</script>
<style scoped>
.search-component {
  position: relative;
}

.search-component .results {
  position: absolute;
  width: calc(100% - 10px);
  background: rgba(255, 255, 255, 0.91);
  margin: 5px;
  max-height: 300px;
  overflow: auto;
}
</style>
